import axios from 'axios';

interface ContactFormData {
  name: string;
  email: string;
  phone?: string;
  message: string;
  recaptchaToken: string;
}

const CONTACT_API_URL = process.env.REACT_APP_CONTACT_API_URL || '';

// eslint-disable-next-line import/prefer-default-export
export async function submitContactForm(data: ContactFormData) {
  if (!CONTACT_API_URL) {
    throw new Error('Contact API URL is not configured');
  }
  return axios.post(CONTACT_API_URL, data, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
}
